import { useEffect } from 'react';

const BASE_TITLE = 'Predico - Collaborative Forecasting';
// index.html ships a canonical link to the homepage; without this every SPA
// route (e.g. /terms) would declare itself a duplicate of `/`.
const SITE_ORIGIN = 'https://predico.inesctec.pt';

export default function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | Predico` : BASE_TITLE;
    const canonical = document.querySelector('link[rel="canonical"]');
    canonical?.setAttribute('href', `${SITE_ORIGIN}${window.location.pathname}`);
    return () => {
      document.title = BASE_TITLE;
      canonical?.setAttribute('href', `${SITE_ORIGIN}/`);
    };
  }, [title]);
}
